import React from "react";
import axios from "axios";
import {
  THUMBOR_DOMAIN_URL,
  B2B2C_LISTING_BASE_IMGURL,
  B2B2C_AUTH_PUBLIC_KEY,
  BUILD_TYPE,
  LOCAL_START,
  B2B2C_LOCALSTORAGE_KEY,
  LEO_TEMPLATE_START,
} from "./Constants";
import LocalStorage from "./LocalStorage";
import Auth from "./Authenticate";
import { monthNames } from "./Constants";
import MytripKartTemplates from "MytripkartTemplates";
import {
  stagingLeoTemplateData,
  stagingHomePageData,
  stagingWebsiteData,
  prodLeoTemplateData,
  prodHomePageData,
  prodWebsiteTemplateData,
} from "./mockData";
const _authorization = `Api-Key ${B2B2C_AUTH_PUBLIC_KEY}`;
export const AppContext = React.createContext();
export const MyTripKart = React.createContext();
export const RemittanceContext = React.createContext();
export const WebContext = React.createContext();
export const GlobalContext = React.createContext();
export const CMSContext = React.createContext();
export const FlightsResultsContext = React.createContext();

export const scrollToBottom = (behavior, timeout, elemId = "chatBox") => {
  try {
    let chatBoxElement = document.getElementById(elemId);
    if (chatBoxElement) {
      let obj = {
        top: chatBoxElement.scrollHeight,
        left: 0,
        // behavior: 'smooth'
      };
      if (behavior != undefined && behavior != null) {
        obj["behavior"] = behavior;
      }

      if (timeout == undefined) {
        chatBoxElement.scroll(obj);
      } else if (timeout != undefined && timeout > 0) {
        setTimeout(chatBoxElement.scroll(obj), timeout);
      }
    }
  } catch (e) {
    console.error("scrolling failed ", e);
  }
};


export const getJsonDataFromLS = (key) => {
  var jsonString = localStorage.getItem(key);
  return JSON.parse(jsonString);
};

// showLoader: function () {
//     $("#loader").addClass("showElement")
// },
// hideLoader: function () {
//     $("#loader").removeClass("showElement")
// },
export const AmountWithCommas = (x) => {
  var parts = x.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
};

export const Title = (str) => {
  /*Convert to title case if all the letters are in upper case*/
  if (str.match(/[a-z]/) == null && str.match(/[A-Z]/) != null) {
    /* https://medium.freecodecamp.org/three-ways-to-title-case-a-sentence-in-javascript-676a9175eb27 */
    str = str
      .toLowerCase()
      .split(" ")
      .map(function (word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      });
    return str.join(" ");
  }

  return str;
};

export const getUrlParameter = (sParam) => {
  if (typeof window !== "undefined") {
    var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split("&"),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split("=");

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined
          ? true
          : decodeURIComponent(sParameterName[1]);
      }
    }
  }
};

export const getInitials = (name) => {
  var initials = name.match(/\b\w/g) || [];
  initials = ((initials.shift() || "") + (initials.pop() || "")).toUpperCase();
  return initials;
};

export const isToday = (someDate) => {
  const today = new Date();
  return (
    someDate.getDate() == today.getDate() &&
    someDate.getMonth() == today.getMonth() &&
    someDate.getFullYear() == today.getFullYear()
  );
};

export const formatDate = (date) => {
  var dateobj = new Date(date);
  if (isToday(dateobj)) {
    return dateobj.toLocaleTimeString();
  } else {
    return dateobj.getDate() + "/" + dateobj.getMonth();
  }
};

export const formatDateTime = (dateTime) => {
  var dateobj = new Date(dateTime);
  return dateobj.toLocaleDateString() + " " + dateobj.toLocaleTimeString();
};

export const getFileNameFromUrl = (url = "") => {
  if (!url) return "";
  return url.substring(url.lastIndexOf("/") + 1);
};

export const dateConvertToAmPm = (date) => {
  var dateobj = new Date(date);
  if (isToday(dateobj)) {
    let time = dateobj.toLocaleTimeString();
    // Check correct time format and split into components
    time = time
      .toString()
      .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) {
      // If time format correct
      time = time.slice(1); // Remove full string match value
      time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
      time.splice(3, 1);
    }
    return time.join(""); // return adjusted time or original string
  } else {
    return dateobj.getDate() + "/" + dateobj.getMonth();
  }
};


export const getShortenDescription = (val, length) => {
  if (val && val.length > length) {
    return `${val.substring(0, length)}..`;
  }
  return val;
};

export const htmlDecode = (msg) => {
  try {
    msg = msg.replace(/<(?:.|\n)*?>/gm, "");
    const dummyElement = document.createElement("p");
    dummyElement.innerHTML = decodeURIComponent(
      JSON.parse('"' + msg.replace(/\"/g, '\\"') + '"')
    );
    const renderedContent = dummyElement.textContent;
    return renderedContent;
  } catch (e) {
    return msg;
  }
};

export const logout = () => {
  ["user", "memberchat", "requirement", "memberList"].map((item) => {
    LocalStorage.deleteData(item);
  });
  window.location.href = "/en/login";
};

export const devConsolelog = (val, ...others) => {
  if (val && process.env.NODE_ENV == "development") console.log(val, ...others);
};


export const captureEvent = (eventKey, data = {}) => {
  if (typeof window === 'undefined') {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventKey,
    ...(data || {})
  });

  console.log('[GTM event captured]:', eventKey, data);
};

const tempAuthToken =
  "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE2MzM5NDg0NzQsImlhdCI6MTYzMzM0MzY3NCwic3ViIjoyMjg1Nn0.VDzf2bNpC7gPV7A7aFFmhcC1NylVMK--CbTT-JZmwcQ";

export const getApi = (url, headersData = {}) => {
  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json",
        // TODO: comment below data
        source: "website",
        Authorization: tempAuthToken,
        ...headersData,
      },
    })
    .then((response) => {
      // handle success
      devConsolelog("response getapi ", url, response, response.data);
      if (response.status >= 200 && response.status < 300 && response.data)
        return response; //{data: response.data, stats}
      return null;
    })
    .catch(function (error) {
      // handle error
      let { response = {} } = error;
      console.log("catch error ", error, response);
      return { err: error, status: response.status };
    });
};

export const getPublicApi = (url, headersData = {}) => {
  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json",
        // TODO: comment below data
        source: "website",
        ...headersData,
      },
    })
    .then((response) => {
      // handle success
      devConsolelog("response getapi ", url, response, response.data);
      if (response.status >= 200 && response.status < 300 && response.data)
        return response; //{data: response.data, stats}
      return null;
    })
    .catch(function (error) {
      // handle error
      let { response = {} } = error;
      console.log("catch error ", error, response);
      return { err: error, status: response.status };
    });
};

export const getPrivateApi = (url, headersData = {}, loginToken = "") => {
  let authToken = Auth.getTokenFromAuth();
  const finalAuthToken = `Bearer ${authToken || ""}`;
  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json",
        source: "website",
        Authorization: loginToken ? finalAuthToken : _authorization,
        ...headersData,
      },
    })
    .then((response) => {
      // handle success
      devConsolelog("response getapi ", url, response, response.data);
      if (response.status >= 200 && response.status < 300 && response.data)
        return response; //{data: response.data, stats}
      return null;
    })
    .catch(function (error) {
      // handle error
      let { response = {} } = error;
      console.log("catch error ", error, response);
      return { err: error, status: response.status };
    });
};

export const postApi = (url, body, headersData = {}, method = "post") => {
  return axios({
    method,
    url,
    data: body,
    // TODO: comment out headers data
    headers: {
      "Content-Type": "application/json",
      source: "website",
      Authorization: tempAuthToken,
      ...headersData,
    },
  })
    .then((response) => {
      // handle success
      devConsolelog("response getapi ", url, response, response.data);
      if (response.status >= 200 && response.status < 300 && response.data)
        return response; //{data: response.data}
      return null;
    })
    .catch(function (error) {
      // handle error
      let { response = {} } = error;
      console.log("catch error ", error, response);
      return { err: error, status: response.status };
    });
};

export const postPrivateApi = (
  url,
  body,
  headersData = {},
  method = "post",
  isToken = false
) => {
  let authToken = Auth.getTokenFromAuth();
  const finalAuthToken = `Bearer ${authToken || ""}`;

  return axios({
    method,
    url,
    data: body,
    headers: {
      "Content-Type": "application/json",
      source: "website",
      Authorization: isToken ? finalAuthToken : _authorization,
      ...headersData,
    },
  })
    .then((response) => {
      // handle success
      devConsolelog("response getapi ", url, response, response.data);
      if (response.status >= 200 && response.status < 300) {
        return response; //{data: response.data}
      }
      return null;
    })
    .catch(function (error) {
      // handle error
      let { response = {} } = error;
      console.log("catch error ", error, response);
      return { err: error, status: response.status };
    });
};

export const isEmptyObject = (obj) => {
  for (let name in obj) {
    if (obj.hasOwnProperty(name)) {
      return false;
    }
  }
  return true;
};

export const getListingDetailUrl = (item = {}) => {
  let { id = null, title = null } = item;
  if (id && title) {
    console.log("getListingDetailUrl title ", title);
    title = title.replace("/", "-").toLowerCase(); //title.replace(/\//g, "-");
    title = `${id}-${title}`;
    title = title.replace(/[^\d\w]+/g, "-");
    console.log("getListingDetailUrl title final ", title);
    return `${title}`;
  } else return null;
};


export const queryStringToObj = (queryString) => {
  if (queryString) {
    // let searchParams = new URLSearchParams(location.search);
    var searchParams = queryString.substring(1);
    if (searchParams[0] == "&") {
      searchParams = searchParams.substring(1);
    }
    let searchObjString =
      '{"' +
      decodeURI(searchParams)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"') +
      '"}';
    try {
      searchParams = JSON.parse(searchObjString);
    } catch (e) {
      console.log("searchParams error ", e, searchObjString);
      console.log(JSON.stringify(searchObjString));
      return {}; //null
    }
    return searchParams;
  } else return {};
};

export const thumborImageUrl = (imageUrl = "", height = 0, width = 0) => {
  // devConsolelog('thumborImageUrl - ', imageUrl);
  if (!imageUrl) return null;
  // TODO: removed localhost exception for testing, check if necessary
  // if(window.location.origin.indexOf('localhost') > 0 || imageUrl.indexOf('localhost') > 0) return imageUrl;
  const thumborUrl = `${THUMBOR_DOMAIN_URL}${height}x${width}/smart/`;
  let newUrl = `${thumborUrl}${imageUrl}`;
  if (imageUrl.indexOf("http") < 0 || imageUrl.includes("travclan-logo")) {
    newUrl = `${thumborUrl}${
      window.location.origin || "https://travclan.com"
    }${imageUrl}`;
  }
  return newUrl;
};

export const openWhatsApp = (phone = null, message = "") => {
  if (!phone) return;
  let whatsappMsg = window.encodeURIComponent(message);
  try {
    const isMobile = detectMob();
    if (!isMobile) {
      window.open(
        `https://web.whatsapp.com/send?phone=${phone}&text=${whatsappMsg}`,
        "_blank"
      );
    } else {
      window.open(
        `https://api.whatsapp.com/send?phone=${phone}&text=${whatsappMsg}`,
        "_blank"
      );
    }
  } catch (e) {
    window.open(
      `https://api.whatsapp.com/send?phone=${phone}&text=${whatsappMsg}`,
      "_blank"
    );
  }
};

function detectMob() {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
  ];

  return toMatch.some((toMatchItem) => {
    return navigator.userAgent.match(toMatchItem);
  });
}

export const amountINSFormat = (x = null) => {
  if (!x) return null;
  let res = x;
  try {
    x = x.toString();
    let afterPoint = "";
    if (x.indexOf(".") > 0) afterPoint = x.substring(x.indexOf("."), x.length);
    x = Math.floor(x);
    x = x.toString();
    let lastThree = x.substring(x.length - 3);
    let otherNumbers = x.substring(0, x.length - 3);
    if (otherNumbers != "") lastThree = "," + lastThree;
    res =
      otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") +
      lastThree +
      afterPoint;
    return res;
  } catch (e) {
    return res;
  }
};

export const copyTextToClipboard = (
  id = null,
  copyTextAreaContainer = "root",
  cb,
  type = "noninput"
) => {
  if (!copyTextAreaContainer) copyTextAreaContainer = "root";
  if (type == "input") {
    // only for input fields
    let text = document.getElementById(id);
    text.select();
    text.setSelectionRange(0, 99999);
    document.execCommand("copy");
  } else {
    // only for non input fields
    var text = document.getElementById(id).innerText;
    var elem = document.createElement("textarea");
    document.getElementById(copyTextAreaContainer).appendChild(elem);
    elem.value = text;
    elem.select();
    elem.setSelectionRange(0, 99999);
    document.execCommand("copy");
    document.getElementById(copyTextAreaContainer).removeChild(elem);
  }

  if (cb) cb();
  // setViewSnackbar({message:'Link Copied!', type:'success'})
};

const COMMA_FOR_CURRENCY = { INR: amountINSFormat };

export const amountCurrencyFormat = (currency = "", price = null) => {
  if (!price || !currency) return "";

  price = Math.floor(price);
  if (currency in COMMA_FOR_CURRENCY)
    return COMMA_FOR_CURRENCY[currency.toUpperCase()](price);
  else return price;
};

export const getLogoUrl = (
  url = "",
  replaceStr = "https://s3.ap-south-1.amazonaws.com/com.travclan.b2b2c/"
) => {
  if (!url) return "";
  if (typeof url != "string") return url;
  let badUrl = url;
  badUrl = badUrl.split("http");
  if (badUrl.length <= 2) return thumborImageUrl(url.split("?")[0], 0, 100);
  devConsolelog("badUrl ", badUrl, url);
  // contains multiple 'http'

  // if(url.includes('cms/media')) {
  url = decodeURIComponent(url);
  url = url.slice(replaceStr.length + "https:".length);
  url = `https:/${url}`;
  // }
  devConsolelog("badUrl final ", url);
  return thumborImageUrl(url.split("?")[0], 0, 100);
};

export const handleBadImgUrl = (url = "") => {
  if (!url) return "";
  if (typeof url != "string") return url;
  let badUrl = url;
  badUrl = badUrl.split("http");
  if (badUrl.length == 1)
    return `${B2B2C_LISTING_BASE_IMGURL}${url.split("?")[0]}`;
  else if (badUrl.length <= 2) return url.split("?")[0];

  else if (badUrl.length > 2) {
    devConsolelog("badUrl noReplace 1", badUrl, url);
    return `http${badUrl[badUrl.length - 1]}`;
    devConsolelog("badUrl noReplace 2", `http${badUrl[badUrl.length - 1]}`);
  }
  // contains multiple 'http'
};

export const formatDate2 = (inputDate = "") => {
  if (!inputDate) return;
  let date = new Date(inputDate);
  if (!isNaN(date.getTime())) {
    // Months use 0 index.
    return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
  }
};

export const getUTCDate = (
  data,
  format = "dd-mm-yyyy",
  monthInAlphabets = false
) => {
  if (data) console.log("data from params", data);
  if (!data) return "";
  let newDate = (data || "").indexOf("T") > 0 ? data.split("T") : null;
  newDate = newDate[0];
  if (!(format === "yyyy-mm-dd")) {
    try {
      newDate = new Date(newDate); // data
      const dateData = {};
      dateData.yyyy = newDate.getUTCFullYear();
      if (monthInAlphabets) {
        dateData.mm = monthNames[newDate.getUTCMonth()];
      } else
        dateData.mm =
          newDate.getUTCMonth() + 1 < 10
            ? parseInt(`0${newDate.getUTCMonth() + 1}`, 10)
            : newDate.getUTCMonth() + 1;

      dateData.dd =
        newDate.getUTCDate() < 10
          ? parseInt(`0${newDate.getUTCDate()}`, 10)
          : newDate.getUTCDate();
      const formatArr = format.split("-") || [];
      if (formatArr.length > 0) {
        newDate = "";
        formatArr.forEach((item, index) => {
          newDate += `${dateData[item]}`;
          if (index < formatArr.length - 1)
            monthInAlphabets ? (newDate += " ") : (newDate += "-");
        });
      }
    } catch (e) {
      return data;
    }
  }
  return newDate;
};

export const getFormattedDate = (
  data,
  format = "dd-mm-yyyy",
  monthInAlphabets = false
) => {
  if (data) {
    let newDate = data.indexOf("T") > 0 ? data.split("T") : null;
    if (newDate && newDate.length > 0 && format == "yyyy-mm-dd") {
      // date is js date time string
      newDate = newDate[0];
    } else {
      try {
        newDate = new Date(data);
        let dateData = {};
        dateData["yyyy"] = newDate.getFullYear();
        if (monthInAlphabets) {
          dateData["mm"] = monthNames[newDate.getMonth()];
        } else
          dateData["mm"] =
            newDate.getMonth() + 1 < 10
              ? parseInt(`0${newDate.getMonth() + 1}`)
              : newDate.getMonth() + 1;
        dateData["dd"] =
          newDate.getDate() < 10
            ? parseInt(`0${newDate.getDate()}`)
            : newDate.getDate();
        let formatArr = format.split("-");
        if (formatArr.length > 0) {
          newDate = "";
          formatArr.forEach((item, index) => {
            newDate += `${dateData[item]}`;
            if (index < formatArr.length - 1) newDate += "-";
          });
        }
      } catch (e) {
        return data;
      }
    }
    return newDate;
  }
};

export const IsEmail = (email) => {
  var regex =
    /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  if (!regex.test(email)) {
    return false;
  } else {
    return true;
  }
};

export const capitalizeStr = (string = "") => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const copyImgToClipboard = (canvas = null, cb) => {
  if (!canvas) return;
  if (navigator.clipboard) {
    const { ClipboardItem } = window;
    canvas.toBlob(
      async (blob) =>
        await navigator.clipboard.write([
          new ClipboardItem({ [blob.type]: blob }),
        ])
    );
  } else {
    var img = document.createElement("img");
    img.src = canvas.toDataURL();
    var div = document.createElement("div");
    div.contentEditable = true;
    div.appendChild(img);
    document.body.appendChild(div);

    // do copy
    SelectText(div);
    document.execCommand("Copy");
    document.body.removeChild(div);
  }
  if (cb) cb();
};

function SelectText(element) {
  var doc = document;
  if (doc.body.createTextRange) {
    var range = document.body.createTextRange();
    range.moveToElementText(element);
    range.select();
  } else if (window.getSelection) {
    var selection = window.getSelection();
    var range = document.createRange();
    range.selectNodeContents(element);
    selection.removeAllRanges();
    selection.addRange(range);
  }
}

export const copyToClipWithFormating = (id = null, cb) => {
  if (!id) return;
  let str = document.getElementById(id).innerHTML;
  function listener(e) {
    e.clipboardData.setData("text/plain", str);
    e.preventDefault();
  }
  document.addEventListener("copy", listener);
  document.execCommand("copy");
  document.removeEventListener("copy", listener);
  if (cb) cb();
};

export const getCategoryName = (
  id,
  categoryType = [],
  key = "name",
  filterKey = "value"
) => {
  //CURRENCIES
  if (!id && typeof Number(id) != "number") return;
  let catName = categoryType.find((x) => x[filterKey] == id);
  return (catName && catName[key]) || null;
};

export const LoadingComponent = (props) => {
  if (props.error) {
    // When the loader has errored
    return (
      <div>
        Error! <button onClick={props.retry}>Retry</button>
      </div>
    );
  } else if (props.timedOut) {
    // When the loader has taken longer than the timeout
    return (
      <div>
        Taking a long time... <button onClick={props.retry}>Retry</button>
      </div>
    );
  } else if (props.pastDelay) {
    // When the loader has taken longer than the delay
    return <div>Loading...</div>;
  } else {
    // When the loader has just started
    return null;
  }
};

export const getDomainName = (domain_name = "") => {
  const regex = "www.";
  if (domain_name.indexOf(regex) === 0) return domain_name.replace(regex, "");
  else return domain_name;
};

export const getDomainValue = () => {
  let hostname = window.location.hostname;
  let domain_name = "";
  if (
    hostname.includes("mytripkart.in") ||
    hostname.includes("localhost") ||
    hostname.includes("dev.travclan.com")
  ) {
    domain_name = window.location.pathname.split("/")[1];
  } else domain_name = getDomainName(hostname);
  return domain_name;
};

export const checkIsValidArray = (arr = []) => {
  if (Array.isArray(arr) && arr.length > 0) return true;
  return false;
};

export const isValidObject = (obj) => {
  if (!obj) return false;
  if (typeof obj !== "object") return false;
  if (typeof obj === "object" && Array.isArray(obj)) return false;
  return Object.keys(obj).length > 0 ? obj : {};
};

export const selectOptionsLabelKeyMapper = (
  data,
  mapKeys = {
    label: "label",
    value: "value",
    id: "id",
  },
  getAllDataAfterMapping = false,
  customExtractor = {
    getLabel: null,
    getValue: null,
    getId: null,
  }
) => {
  if (checkIsValidArray(data) && isValidObject(mapKeys)) {
    return data?.map((dataItem) => ({
      ...(getAllDataAfterMapping ? { ...dataItem } : {}),
      label: customExtractor.getLabel
        ? customExtractor.getLabel(dataItem)
        : dataItem?.[mapKeys?.label],
      value: customExtractor.getLabel
        ? customExtractor.getValue(dataItem)
        : dataItem?.[mapKeys?.value],
      id: customExtractor.getLabel
        ? customExtractor.getId(dataItem)
        : dataItem?.[mapKeys?.id],
    }));
  }
  return [];
};

export const urlParamsMaker = (BASE_URL, params) => {
  // example params [[key,value],[key,value]]
  const totalParams = params.length;
  const isValidArray = Array.isArray(params) && totalParams > 0;
  if (isValidArray) {
    return params.reduce((prev, curr, idx) => {
      const [key, value] = curr;

      if (!key || (!value && typeof value !== "number")) return prev;

      if (idx === 0) {
        prev += `?${key}=${value}`;
      } else {
        prev += `&${key}=${value}`;
      }

      return prev;
    }, BASE_URL);
  }
  return BASE_URL;
};

export function getTripkartTemplates() {
  // for local development replace first MytripKartTemplates with LocalMyTripkarTemplates
  return LOCAL_START ? MytripKartTemplates : MytripKartTemplates;
}

export function getPrefilledJson() {
  if (LEO_TEMPLATE_START) {
    if (BUILD_TYPE === "PRODUCTION") {
      return {
        HOME_PAGE_DATA: prodHomePageData,
        TEMPLATE_DATA: prodLeoTemplateData,
      };
    } else {
      return {
        HOME_PAGE_DATA: stagingHomePageData,
        TEMPLATE_DATA: stagingLeoTemplateData,
      };
    }
  } else {
    if (BUILD_TYPE === "PRODUCTION") {
      return {
        HOME_PAGE_DATA: prodHomePageData,
        TEMPLATE_DATA: prodWebsiteTemplateData,
      };
    } else {
      return {
        HOME_PAGE_DATA: stagingHomePageData,
        TEMPLATE_DATA: stagingWebsiteData,
      };
    }
  }
}

export const getB2B2CUser = () => {
  if (localStorage.getItem(B2B2C_LOCALSTORAGE_KEY)) {
    let B2B2C_USER = null;
    try {
      const parseUserInfo = JSON.parse(
        localStorage.getItem(B2B2C_LOCALSTORAGE_KEY)
      );
      B2B2C_USER = typeof parseUserInfo == "object" && parseUserInfo;
    } catch (err) {
      console.error("There was a error while parsing user");
    } finally {
      return B2B2C_USER;
    }
  }
  return null;
};
